'use strict';

var _ = require('lodash');
var ReviewInputDataChartController = function ReviewInputDataChartController($scope, dataProviderService, formatter) {
  $scope.contextMenuItems = [{
    caption: 'Mark Exclusion',
    event: 'context-menu:input-data-chart-mark-exclusion'
  }];
  $scope.legendItems = dataProviderService.getLegend();
  $scope.filter = {};
  $scope.userExclusionsForMarkets = [];
  $scope.isChartVisible = true;
  $scope.updateChart = function () {
    redrawChart();
  };
  $scope.initChart = function () {
    $scope.changeMetricHandler($scope.selectedMetric);
  };
  $scope.changeMetricHandler = function (metric) {
    $scope.selectedMetric = metric;
    redrawChart();
  };
  $scope.$on('chart-legend:legend-filter-changed', function (evt, data) {
    $scope.filter = data;
    redrawChart();
  });
  $scope.$on('seasonality-review-input-data:process-user-exclusion-event', function (evt, userExclusionEventsDataForMarket) {
    processUserExclusionForMarket(userExclusionEventsDataForMarket);
    if (isMarketSelected(userExclusionEventsDataForMarket.market)) {
      redrawChart();
    }
  });
  $scope.createUserExclusionEvent = function (weekNos) {
    var firstWeekInSelection = _.chain(weekNos).first().first().add(1).value();
    var lastWeekInSelection = _.chain(weekNos).first().last().value();
    var eventsData = [];
    _.range(firstWeekInSelection, lastWeekInSelection + 1).forEach(function (week) {
      var weekData = _.find($scope.data, {
        'weekNumber': week
      });
      eventsData.push(getUserExclusionEventData(week, weekData.weekStartDateMoment));
    });
    $scope.$emit('seasonality-review-input-data:mark-user-exclusion', eventsData);
  };
  function getUserExclusionEventData(week, startDateMoment) {
    return {
      week: week,
      startDateMoment: startDateMoment,
      market: $scope.filter.selectedMarket,
      allWeek: $scope.filter.allWeek,
      dowSelection: $scope.filter.dowSelection
    };
  }
  function processUserExclusionForMarket(newEventsData) {
    var datesToAdd = [];
    _.forEach(newEventsData.add, function (item) {
      datesToAdd = _.concat(datesToAdd, getDatesArray(item.startDate, item.endDate));
    });
    var datesToRemove = [];
    _.forEach(newEventsData.remove, function (item) {
      datesToRemove = _.concat(datesToRemove, getDatesArray(item.startDate, item.endDate));
    });
    var existingExclusionDatesForMarket = $scope.userExclusionsForMarkets[newEventsData.market];
    $scope.userExclusionsForMarkets[newEventsData.market] = updateUserExclusionsForMarket(existingExclusionDatesForMarket, datesToRemove, datesToAdd);
  }
  function updateUserExclusionsForMarket(existingExclusionDatesForMarket, datesToRemove, datesToAdd) {
    if (existingExclusionDatesForMarket === undefined) {
      existingExclusionDatesForMarket = datesToAdd;
    } else {
      existingExclusionDatesForMarket = _.chain(existingExclusionDatesForMarket).differenceWith(datesToRemove, function (obj1, obj2) {
        return obj1.isSame(obj2, 'day');
      }).unionWith(datesToAdd, function (obj1, obj2) {
        return obj1.isSame(obj2, 'day');
      }).value().sort(function (obj1, obj2) {
        if (obj1.isBefore(obj2, 'day')) {
          return -1;
        } else if (obj1.isAfter(obj2, 'day')) {
          return 1;
        }
        return 0;
      });
    }
    return existingExclusionDatesForMarket;
  }
  function getDatesArray(startDate, endDate) {
    var dates = [];
    var oneDayAfterEndDate = endDate.add(1, 'days');
    var currDate = startDate;
    while (currDate.isBefore(oneDayAfterEndDate, 'day')) {
      dates.push(currDate);
      currDate = currDate.add(1, 'days');
    }
    return dates;
  }
  function isMarketSelected(market) {
    return market === $scope.filter.selectedMarket;
  }
  function allDataAvailable() {
    return $scope.filter.selectedMarket && $scope.selectedMetric;
  }
  function redrawChart() {
    $scope.setLoadingMessage();
    if (!allDataAvailable()) {
      $scope.setLoadingMessage('No data to display');
      return;
    }
    var metric = $scope.selectedMetric.id;
    var filter = $scope.filter;
    var exclusionDates = $scope.userExclusionsForMarkets[filter.selectedMarket] || [];
    dataProviderService.getData(filter.selectedMarket, filter.spos, filter.classGroup, $scope.calendar.dateRangeFrom, $scope.calendar.dateRangeTo, metric, filter.dowSelection, filter.allWeek, filter.displayMode, exclusionDates).then(function (chartData) {
      $scope.data = chartData.data;
      $scope.renderChart(chartData.data);
      if (chartData.data && chartData.data.length) {
        $scope.setInitialSelection([0, $scope.data.length]);
      }
    });
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: formatter.identity,
    yAxisTickFormatter: formatter.humanReadable
  };
};
ReviewInputDataChartController.$inject = ['$scope', 'ReviewInputDataChartServiceProvider', 'FormatterService'];
module.exports = ReviewInputDataChartController;